import ModelUtil from '@leverege/model-util';
import { Formatters } from "../../../../../attribute/index.js";
function createModel(type) {
  const formatterValueType = type?.endsWith('*') ? type.replace('*', '') : type;
  const TYPE = `attr.customTextAttribute.${type}`;
  function create(opts) {
    const {
      attrName,
      objectType,
      formatter
    } = opts || {};
    return {
      type: TYPE,
      attrName,
      objectType,
      formatter: formatter || Formatters.createFormatterModel(formatterValueType)
    };
  }
  return {
    TYPE,
    create,
    ...ModelUtil.createAllValue('formatter')
  };
}
export default {
  createModel
};